export default __webpack_public_path__ + "static/media/YAS0530.34I-27791_-17193_0.d943bc2a.jpg";